import React, { useState } from 'react';
import { Accordion, AccordionBody, AccordionHeader, AccordionItem } from 'react-headless-accordion';
import { IoIosArrowBack } from 'react-icons/io';

const Accordion2 = ({ type }) => {
    const [rotationState, setRotationState] = useState(false);

    const toggleRotation = () => {
        setRotationState(!rotationState);
    };

    const accordionTransitionDuration = 500; // Set the same duration as the accordion transition

    const accordionClass = () => {
        switch (type) {
            case 'rounded':
                return 'max-w-[500px] mx-auto border-accordionBorderColor bg-gradient-to-r from-accordionMainColor to-accordionSecondaryColor rounded-2xl border-[4px] shadow-lg';
            case 'rectangle':
                return 'max-w-[500px] mx-auto border-accordionBorderColor rounded-none bg-gradient-to-r from-accordionMainColor to-accordionSecondaryColor border-[4px] shadow-lg';
            default:
                return '';
        }
    };

    return (
        <div className='mt-6 mx-auto px-4 pb-8'>
            <Accordion
                className={accordionClass()}
                transition={{ duration: `${accordionTransitionDuration}ms`, timingFunction: 'cubic-bezier(0, 0, 0.2, 1)' }}
            >
                <AccordionItem>
                    <AccordionHeader
                        className='bg-gradient-to-r from-accordionMainColor to-accordionSecondaryColor items-center text-accordion_headerColor flex p-4 w-full justify-between rounded-2xl'
                        onClick={toggleRotation}
                    >
                        <IoIosArrowBack
                            className={`${rotationState ? 'rotate-90' : ''} text-2xl text-accordion_iconColor`}
                            style={{ transition: `transform 0.5s ease-in-out` }}
                        />
                        <h3 className='text-2xl font-bold'>השתלמויות למתקדמות</h3>
                    </AccordionHeader>

                    <AccordionBody>
                        <div dir='rtl' className='text-accordionTextColor text-right font-medium p-4 rounded-b-2xl'>




                            <ul className='mr-5 text-lg text-white '>
                                <li className='list-disc font-bold'>
                                    השתלמות גבות
                                </li>
                                <li className='list-disc font-bold mt-2'>
                                    השתלמות שפתיים
                                </li>
                                <li className='list-disc font-bold mt-2'>
                                    השתלמות עיניים
                                </li>

                            </ul>

                            <p className='text-lg font-bold text-yellow-200 mt-4'>
                                * מתאים למתקדמות
                            </p>

                        </div>
                    </AccordionBody>
                </AccordionItem>
            </Accordion>
        </div>
    );
};

export default Accordion2;
